import i18n from "../i18n/i18n";

export function validateVerificationCodeInput(code) {
  if (!code) {
    return i18n.t("errors.pleaseEnterVerificationCode", "Please enter the verification code.");
  }
  return null;
}

export function parseVerificationCodeError(error) {
  const status = error?.status ?? error?.response?.status;
  if (!status) {
    return i18n.t("errors.unexpectedError", "An unexpected error occurred. Please try again later.");
  }
  switch (status) {
    case 404:
      return i18n.t("errors.invalidVerificationCode", "Invalid verification code.");
    case 400:
      return i18n.t("errors.invalidRequest", "Invalid request. Please check your input.");
    case 500:
      return i18n.t("errors.serverError", "Server error. Please try again later.");
    case 502:
    case 503:
    case 504:
      return i18n.t("errors.serviceUnavailable", "Service is temporarily unavailable. Please try again later.");
    default:
      return i18n.t("errors.genericError", "An error occurred. Please try again.");
  }
}
